module.exports = __webpack_public_path__ + "img/icon_vip_elm@2x.0b407102.png";